import script from "./Layers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Layers.vue?vue&type=script&setup=true&lang=ts"

import "./Layers.vue?vue&type=style&index=0&id=384e5b31&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384e5b31"]])

export default __exports__